import type { TestAnswerPdfDetails } from "@/utils/testAnswerPdfDetails";

type TestAnswerPdfDetailsPageProps = {
    details: TestAnswerPdfDetails;
};

export default function TestAnswerPdfDetailsPage(props: TestAnswerPdfDetailsPageProps) {
    const { details } = props;

    if (!details?.rows?.length) {
        return null;
    }

    return (
        <div className="tableWrapper factTable centered testDetailsTable formTable testAnswerPdfDetailsPage">
            <table>
                <caption>
                    <span className="title">Details</span>
                </caption>
                <tbody>
                    {details.rows.map((row) => (
                        <tr key={row.label}>
                            <th>{row.label}</th>
                            <td>{row.value}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
